import MailIcon from '~/assets/icons/Mail';

export default function EmailSubmitting() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 bg-grey-tile px-2 py-4">
      <MailIcon width="42" height="42" stroke="#A9A9A9" />
      <span className="text-grey-hide">Sending confirmation...</span>
    </div>
  );
}
